/*
 * NgbDatepicker formatter
 * <p>
 *
 * @author lachezar.parvin
 * @author Gallagher Bassett IT
 * @author Copyright (c) 2020 Gallagher Bassett Services, Inc.
 *
 */

import { Injectable } from "@angular/core";
import {
  NgbDateParserFormatter,
  NgbDateStruct
} from "@ng-bootstrap/ng-bootstrap";

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable ()
export class ReporterCustomDateParserFormatter extends NgbDateParserFormatter {

  readonly DELIMITER = '/';
  readonly DASH_DELIMITER = '-';

  parse( value: string ): NgbDateStruct | null {
    if ( value ) {
      // Check if format matches yyyy-mm-dd variants
      if ( /^\d{4}-\d{2}-\d{2}$/.test ( value ) ) {
        const [ year, month, day ] = value.split ( this.DASH_DELIMITER ).map ( val => parseInt ( val, 10 ) );
        return { year, month, day };
      }
      // Check if format matches mm/dd/yyyy variants
      if ( /^\d{1,2}\/\d{1,2}\/\d{4}$/.test ( value ) ) {
        const [ month, day, year ] = value.split ( this.DELIMITER ).map ( val => parseInt ( val, 10 ) );
        return { day, month, year };
      }
    }
    return null;
  }

  format( date: NgbDateStruct | null ): string {
    return date
      ? `${ date.month }`.padStart ( 2, '0' ) + this.DELIMITER + `${ date.day }`.padStart ( 2, '0' ) + this.DELIMITER + date.year
      : '';
  }
}
